import React from 'react';
import { Box, MenuItem, TextField } from '@mui/material';
import { searchSummary } from '../common/form/MobileFilterCollapse';
import SearchCard, { fieldProps } from '../common/list/SearchCard';
import SearchCodeSelectbox from '../common/form/selectbox/SearchCodeSelectbox';
import MobileSearchAdornment from '../common/search/MobileSearchAdornment';

// 거래처관리(/partnermng) 검색 영역 - chancemng 설계(fc30533) 적용(2026-10-22).
// 추가/엑셀 다운로드/엑셀 업로드 버튼은 breadcrumb action으로 옮겼다(PartnerListContainer).
// 휴대폰 "추가" Fab도 거기서 그대로 유지.
export const PartnerListBox = ({ formik, onReset }) => {
  return (
    <SearchCard
      summary={searchSummary(formik.values)}
      onSubmit={formik.handleSubmit}
      onReset={onReset}
      submitting={formik.isSubmitting}
      gridSx={{
        gridTemplateAreas: {
          xs: `"type" "keyword" "search" "btns"`,
          sm: `"type keyword" "search btns"`,
        },
        gridTemplateColumns: {
          xs: '1fr',
          sm: 'minmax(180px, 1fr) minmax(180px, 1fr)',
        },
        '@media (min-width:1440px)': {
          gridTemplateAreas: `"type keyword search btns"`,
          gridTemplateColumns: 'minmax(180px, 0.8fr) minmax(160px, 0.7fr) minmax(200px, 1.3fr) 190px',
        },
      }}
    >
      {/* 거래처 종류 */}
      <Box sx={{ gridArea: 'type', minWidth: 0 }}>
        <SearchCodeSelectbox
          formik={formik}
          variant="outlined"
          size="small"
          label="거래처 종류"
          required={false}
          filterObject={{
            blcCd: 'BASE',
            mlcCd: 'PARTNER',
            slcCd: 'PARTNER_TYP',
          }}
          name="searchPartnerTyp"
        />
      </Box>

      {/* 검색키워드 */}
      <Box sx={{ gridArea: 'keyword', minWidth: 0 }}>
        <TextField
          {...fieldProps}
          select
          fullWidth
          required
          id="searchKeyword"
          name="searchKeyword"
          label="검색키워드"
          value={formik.values.searchKeyword}
          onChange={formik.handleChange}
          error={formik.touched.searchKeyword && Boolean(formik.errors.searchKeyword)}
          helperText={formik.touched.searchKeyword && formik.errors.searchKeyword}
        >
          <MenuItem value="">검색키워드</MenuItem>
          <MenuItem value="partnerNm">회사명</MenuItem>
          <MenuItem value="regNumber">사업자번호</MenuItem>
          <MenuItem value="partnerPhone">연락처</MenuItem>
        </TextField>
      </Box>

      {/* 검색어 */}
      <Box sx={{ gridArea: 'search', minWidth: 0 }}>
        <TextField
          {...fieldProps}
          fullWidth
          required
          id="searchWords"
          name="searchWords"
          label="검색어"
          value={formik.values.searchWords || ''}
          onChange={formik.handleChange}
          error={formik.touched.searchWords && Boolean(formik.errors.searchWords)}
          helperText={formik.touched.searchWords && formik.errors.searchWords}
          InputProps={{
            endAdornment: <MobileSearchAdornment disabled={formik.isSubmitting} />,
          }}
        />
      </Box>
    </SearchCard>
  );
};
